export default __webpack_public_path__ + "static/media/Hello.d3db2332.png";